var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MPModal',{staticClass:"BMmodal",attrs:{"show":_vm.showModal,"show-x":true},on:{"update:show":function($event){_vm.showModal=$event}}},[_c('div',{staticClass:"px-2 px-md-4 py-md-4 py-5",attrs:{"id":"backgroundModal"}},[_vm._t("leftColumn"),_vm._t("rightColumn")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }